<div class="flex flex-column justify-content-evenly gap-3">
    <div class="w-10 m-auto">
        <h3 class="text-center">Comportamiento diario</h3>
        <p-chart type="line" [data]="data" [options]="options" />        
    </div>
</div>